'use strict';

var _ = require('lodash');

/**
 * Post Departure Mode: Flight Analysis - Class tab (select a row in Cabin view) - Grid
 */
var FlightClassGridPostDepartureTransformerFactory = function FlightClassGridPostDepartureTransformerFactory(DataTransformer, momentService) {
  function FlightClassGridPostDepartureTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'class-post-departure';
    this.targetType = ['class-flight-analysis-post-departure', 'profile-chart-flight-cards'];
    this.priority = 1;
  }
  FlightClassGridPostDepartureTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightClassGridPostDepartureTransformer.constructor = FlightClassGridPostDepartureTransformer;
  FlightClassGridPostDepartureTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) > -1;
  };
  FlightClassGridPostDepartureTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightClassGridPostDepartureTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  FlightClassGridPostDepartureTransformer.prototype.transform = function (data) {
    var memorizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memorizedMomentOfEventDate = _.memoize(getMomentOfDate);
    var memorizedMomentOfArrivalTime = _.memoize(getMomentOfTime);
    var memorizedMomentOfDepartureTime = _.memoize(getMomentOfTime);
    var result = [];
    var legClasses = data.domain.legClasses || data.domain.results;
    for (var i = 0, length = legClasses.length; i < length; i++) {
      var entry = legClasses[i];
      var flightDepartureDateMoment = memorizedMomentOfDepartureDate(entry.flightDepartureDate, momentService.FIELD.DEPARTURE_DATE);
      var legDepartureDateMoment = memorizedMomentOfDepartureDate(entry.legDepartureDate, momentService.FIELD.DEPARTURE_DATE);
      var eventTimeStamp = memorizedMomentOfEventDate(entry.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
      var momentDepartureTime = memorizedMomentOfDepartureTime(entry.departureTime, momentService.FIELD.DEPARTURE_TIME, memorizedMomentOfDepartureDate);
      var momentArrivalTime = memorizedMomentOfArrivalTime(entry.arrivalTime, momentService.FIELD.ARRIVAL_TIME, memorizedMomentOfDepartureDate);
      var newEntry = {
        flightId: entry.flightId,
        legId: entry.legId,
        legCabinId: entry.legCabinId,
        legClassId: entry.legClassId,
        flightDepartureDateMoment: flightDepartureDateMoment,
        legDepartureDateMoment: legDepartureDateMoment,
        arrivalTime: momentArrivalTime,
        departureTime: momentDepartureTime,
        leg: entry.leg,
        className: entry.className,
        flightNumber: entry.flightNumber,
        eventTimeStamp: eventTimeStamp,
        cabinIndex: entry.cabinIndex,
        sequence: entry.sequence,
        rank: entry.rank,
        isSetAside: entry.isSetAside,
        cabinCode: entry.cabinCode,
        resHoldGroup: entry.resHoldGroup,
        operatingCarrier: entry.operatingCarrier,
        equipment: entry.equipment,
        resHoldTotal: entry.resHoldTotal,
        opsSuffix: entry.opsSuffix,
        carrier: entry.carrier,
        classDisplaySeq: entry.classDisplaySeq,
        seatsAvailResSys: entry.seatsAvailResSys,
        revenueCurrent: entry.revenueCurrent,
        inventoryAuthorization: entry.inventoryAuthorization
      };
      result.push(newEntry);
    }
    return result;
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  function getMomentOfTime(date, field, memorizedMomentOfDate) {
    return memorizedMomentOfDate(date, field, 'HHmm');
  }
  return FlightClassGridPostDepartureTransformer;
};
FlightClassGridPostDepartureTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = FlightClassGridPostDepartureTransformerFactory;